var routeBlock = {
    $routeBlock: $('.route-block'),

    init: function() {
        var _this = this;

        if (!_this.$routeBlock.length) {
            return;
        }

        _this.$routeBlock.each(function() {
            _this.googleMap.init(this);
        });
    },
    googleMap: {
        init: function(that) {
            //for some reason this fires on its own on pageload...
            //this check prevents errors
            if (that === undefined) {
                return;
            }

            var _this = this,
                $map = $(that).find($('.static-map'));

            _this.that = that;

            var list = $map.attr('data-class');
            var id = $map.attr('id');

            // _this.setMap();
            _this.setDirection(list, id);
        },

        setDirection: function(list, id) {
            var _this = this,
                that = this.that;
            //set variables needed
            var directionsDisplay = new google.maps.DirectionsRenderer();
            var directionsService = new google.maps.DirectionsService();
            //set up empty vars for use in for loops
            var marker, i;

            //create array with list items
            var $list = $(that).find('.' + list);

            //set up locations array
            var locations = [];

            //create request that will be used with the directions API
            //dont optimize waypoints, since the bus will take this actual route
            var request = {
                travelMode: google.maps.TravelMode.DRIVING,
                optimizeWaypoints: false
            };

            //set up map
            var map = new google.maps.Map(document.getElementById(id), {
                zoom: 10,
                center: new google.maps.LatLng(52.1348685, 4.6884425),
                disableDefaultUI: true,
                zoomControl: true
            });

            //for each list item with coordinates: add to an array
            $list.each(function(key, element) {
                var array = [
                    $(element).attr('data-name'),
                    parseFloat($(element).attr('data-latitude')),
                    parseFloat($(element).attr('data-longitude'))
                ];

                locations.push(array);
            });

            directionsDisplay.setMap(map);
            var infowindow = new google.maps.InfoWindow();

            //create each marker
            for (i = 0; i < locations.length; i++) {
                marker = new google.maps.Marker({
                    position: new google.maps.LatLng(locations[i][1], locations[i][2])
                });

                google.maps.event.addListener(
                    marker,
                    'click',
                    (function(marker, i) {
                        return function() {
                            infowindow.setContent(locations[i][0]);
                            infowindow.open(map, marker);
                        };
                    })(marker, i)
                );

                //first marker equals the start of the directions API
                if (i == 0) {
                    request.origin = { lat: locations[i][1], lng: locations[i][2] };
                } else if (i == locations.length - 1) {
                    //last marker equals the destination
                    request.destination = { lat: locations[i][1], lng: locations[i][2] };
                } else {
                    //all other markers are waypoints/stopovers
                    if (!request.waypoints) request.waypoints = [];
                    request.waypoints.push({
                        location: marker.getPosition(),
                        stopover: true
                    });
                }
            }

            //finally set up the direction and display it on the map
            directionsService.route(request, function(result, status) {
                if (status == google.maps.DirectionsStatus.OK) {
                    directionsDisplay.setDirections(result);
                }
            });
        }
    }
};
